import { Grid, Button, Divider, debounce } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import { React, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import InstructorAssignCard from './InstructorAssignCard';
import Theme from '../ui/Theme';
import CustomSearchField from '../shared/CustomSearchField';

const useStyles = makeStyles(() => ({
  frameStyle: {
    width: '500px',
    height: '45px',
  },
  contentStyle: {
    width: '500px',
    height: '300px',
    marginLeft: 'calc(50% - 500px/2)',
  },
  titleFrame: {
    width: '283px',
    height: '45px',
  },
  searchFrame: {
    width: '270px',
    height: '49px',
    background: Theme.palette.secondary.main,
    marginLeft: '2%',
  },
  closeIcon: {
    width: '26px',
    height: '26px',
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
  },
  filterIcon: {
    width: '73px',
    height: '49px',
    backgroundColor: '#FAFAFA',
    cursor: 'pointer',
    padding: '8px',
    '&:hover': {
      backgroundColor: 'FAFAFA',
    },
  },
  titleText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#000000',
  },

  searchText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '0px',
    color: 'black',
  },
  mainContent: {
    background: Theme.palette.secondary.main,
    alignItems: 'center',
  },
  buttonGroup: {
    marginLeft: '14%',
  },
  cancelButton: {
    width: '111px',
    height: '42px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  submitButton: {
    width: '216px',
    height: '42px',
    marginLeft: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  titleSubText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    marginTop: '8px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  searchBox: {
    height: '42px',
    width: '100%',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    margin: '16px 0px',
    background: '#FEFEFE',
  },
}));
const AssignInstructor = ({ open, close, handleAssignInstr }) => {
  const classes = useStyles();

  const [viewAssign, setViewAssign] = useState(open);
  const [filterArray, setFilterArray] = useState([]);

  const instrList = useSelector((state) => state.getGuideInstructorList.guideInstrList);

  useEffect(() => {
    if (instrList) setFilterArray(instrList);
    else setFilterArray([]);
  }, [instrList]);

  const handleClosePopup = () => {
    setViewAssign(false);
    close();
  };

  const handleSearch = useCallback(
    ({ target: { value } }) => {
      const filtered = instrList.filter((instr) => instr.name.toLowerCase().includes(value.toLowerCase()));
      setFilterArray(filtered);
    },
    [instrList],
  );

  const submit = () => {
    handleAssignInstr();
    close();
  };

  return (
    <div>
      <Modal
        onRequestClose={() => false}
        shouldCloseOnEsc={false}
        isOpen={viewAssign}
        style={{
          overlay: {
            backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
          },
          content: {
            padding: '20px 16px 28px',
            width: '500px',
            height: '502px',
            background: '#FFFFFF',
            top: '1%',
            left: '35vw',
            overflow: 'hidden',
          },
        }}
      >
        <Grid container direction="column">
          <Grid item className={classes.frameStyle}>
            <Grid container direction="row" justifyContent="space-between">
              <Grid item className={classes.titleFrame}>
                <Grid container direction="column">
                  <Grid item className={classes.titleText}>
                    Assign Instructors
                  </Grid>
                  <Grid item className={classes.titleSubText}>
                    To Guide
                  </Grid>
                </Grid>
              </Grid>
              <Grid item onClick={handleClosePopup}>
                <CloseIcon className={classes.closeIcon} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item className={classes.searchBox}>
            <CustomSearchField handleSearch={debounce(handleSearch, 300)} placeholder="Search Instructor" />
          </Grid>
          <Grid item className={classes.contentStyle}>
            <InstructorAssignCard listVal={filterArray} />
          </Grid>
          <Divider
            style={{
              width: '500px',
              marginTop: '30px',
              marginBottom: '24px',
              marginLeft: '16px',
            }}
          />
          <Grid item>
            <Grid container direction="row" className={classes.buttonGroup}>
              <Grid item>
                <Button variant="contained" onClick={close} disableElevation className={classes.cancelButton}>
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button variant="contained" color="primary" className={classes.submitButton} onClick={submit}>
                  Assign Instructor
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Modal>
    </div>
  );
};
export default AssignInstructor;
